module.exports = __webpack_public_path__ + "static/img/person-2.08afdf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/person-2.png
// module id = /emX
// module chunks = 1